'use strict';

var textConverter = require('./text-converter.js');

var self = module.exports = {
	getObjectFromString: function(str, initObject) {
		str = str || '';
		var obj = initObject || {};
		
		if (str !== '') {
			var index, groups = str.split(';'), length = groups.length;
				
			if (length === 0) {
				groups = str.split(',');
				length = groups.length;
			}
				
			for (index = 0; index < length; index++)
			{
				var attr = groups[index].split(':');				
				var prop = textConverter.hyphenToCamelCase(attr[0].trim());

				if (prop) {
					if (attr.length > 2) {
						attr.splice(0, 1);	
						obj[prop] = self.getValueFromString(attr.join(':').trim());
					} else {
						obj[prop] = self.getValueFromString(attr[1].trim());
					}
				}
			}
		}
		
		return obj;
	},

	getValueFromString: function (str) {
		var val = str;
		
		if (str !== 'undefined')
		{
			if (!isNaN(str)) {
				val = Number(str);
			} else if (str.toLowerCase() === 'true') {
				val = true;
			} else if (str.toLowerCase() === 'false') {
				val = false;
			}
		}
						
		return val;
	}
};